import { Import } from '../type/import.type';

export class InitImport {
  static readonly type = '[Import] Init';
}

export class NewImport {
  static readonly type = '[Import] New';
}

export class AddFile {
  static readonly type = '[Import] Add File';
  constructor(public index: number, public file: File) {}
}

export class TriggerLibelleUpdate {
  static readonly type = '[Import] Trigger Libelle Update';
  constructor(public index: number, public libelle: string) {}
}

export class UpdateLibelle {
  static readonly type = '[Import] Update Libelle';
  constructor(public index: number, public libelle: string) {}
}

export class ImportBreadcrumbAction {
  static readonly type = '[Import] Breadcrumb Action';
  constructor(public step: number) {}
}

export class SendImports {
  static readonly type = '[Import] Send';
}

export class VisualizeEmissions {
  static readonly type = '[Import] Visualize Emissions';

  constructor(public payload: { imports: Import[]; fields: string[] }) {}
}

export class SelectedImports {
  static readonly type = '[Import] Select Imports';
  constructor(public imports: Import[]) {}
}

export class NewExtract {
  static readonly type = '[Import] New Extract';
  constructor(public payload: { emailType: 'basic' | 'fret21'; selectedFiles: string}) {}
}

